const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// mutable runtime overridden by SettingsProvider from /api/settings
export const runtime = {
  waNumber: "918809754990",
};

export const STORE = {
  name: "SONIA DRY FRUITS JAMMU",
  short: "Sonia Dry Fruits",
  logo: "/logo.jpg",
  phone: "+91 88097 54990",
  address: "Shop No. 4, Hari Market, Outside Raghunath Mandir Gate No. 2, Jammu 180001, India",
  hours: "Mon – Sun · 9:00 AM – 9:00 PM",
  upiId: "7742004257@digikhata",
  upiName: "Manisha Tate",
  qrImage: "/qr.jpg",
};

// Resolve backend-served files (/api/files/...) to absolute URLs; public paths as-is
export const assetUrl = (p) => (!p ? "" : p.startsWith("/api/") ? `${BACKEND_URL}${p}` : p);

export const formatINR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const waLink = (text) =>
  `https://wa.me/${runtime.waNumber}?text=${encodeURIComponent(text)}`;

export const buildOrderMessage = ({ customer, items, subtotal, discount, shipping, total }) => {
  const lines = [];
  lines.push("*NEW ORDER — Sonia Dry Fruits Jammu*");
  lines.push("");
  if (customer?.name) {
    lines.push(`*Name:* ${customer.name}`);
    lines.push(`*Mobile:* ${customer.mobile}`);
    if (customer.email) lines.push(`*Email:* ${customer.email}`);
    lines.push(`*Address:* ${customer.address}, ${customer.city}, ${customer.state} - ${customer.pincode}`);
    lines.push("");
  }
  lines.push("*Products:*");
  items.forEach((it, i) => {
    lines.push(`${i + 1}. ${it.name} (${it.weight_label}) x${it.qty} = ${formatINR(it.price * it.qty)}`);
  });
  lines.push("");
  lines.push(`Subtotal: ${formatINR(subtotal)}`);
  if (discount) lines.push(`Discount: -${formatINR(discount)}`);
  lines.push(`Shipping: ${shipping ? formatINR(shipping) : "FREE"}`);
  lines.push(`*Total: ${formatINR(total)}*`);
  return lines.join("\n");
};
